import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { FaBars, FaTimes, FaHome, FaPlus, FaTable, FaSignOutAlt } from "react-icons/fa";
import Modal from "react-bootstrap/Modal";
import Crear from "../Consultas/Crear";
import "./HeaderRoot.css";

const HeaderRoot = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [showAgregarModal, setShowAgregarModal] = useState(false);
    const navigate = useNavigate();

    const toggleMenu = () => setMenuOpen(!menuOpen);
    const openAgregarModal = () => setShowAgregarModal(true);
    const closeAgregarModal = () => setShowAgregarModal(false);

    // Función para cerrar sesión
    const handleLogout = () => {
        // Aquí puedes limpiar el estado de autenticación o eliminar tokens
        console.log("Cerrando sesión...");
        localStorage.removeItem("token"); // Ejemplo: Eliminar token de autenticación
        navigate("/login"); // Redirigir al usuario a la página de login
    };

    return (
        <>
            <header>
                <div className="header-container">


                    {/* MENÚ DESKTOP */}
                    <nav className="navdesktop">
                        <div className="crud d-flex">

                            {/* Botón Home */}
                            <NavLink to="/perca" className="nav-link">
                                <FaHome className="me-2" /> Home
                            </NavLink>

                            {/* Botón Agregar */}
                            <NavLink to="/crear" className="nav-link" onClick={toggleMenu}>
                                <FaPlus className="me-2" /> Agregar
                            </NavLink>

                            {/* Botón Tabla */}
                            <NavLink to="/tabla" className="nav-link">
                                <FaTable className="me-2" /> Tabla
                            </NavLink>
                        </div>
                        <div className="logout">

                            {/* Botón Logout */}
                            <button className="nav-link btn-logout" onClick={handleLogout}>
                                <FaSignOutAlt className="me-2" /> Logout
                            </button>
                        </div>
                    </nav>

                    {/* BOTÓN MENÚ MOBILE */}
                    <button onClick={toggleMenu} className="menu-button">
                        {menuOpen ? <FaTimes /> : <FaBars />}
                    </button>
                </div>

                {/* MENÚ MOBILE */}
                {menuOpen && (
                    <div className="nav-mobile">
                        {/* Botón Home */}
                        <NavLink to="/perca" className="nav-link" onClick={toggleMenu}>
                            <FaHome className="me-2" /> Home
                        </NavLink>

                        {/* Botón Agregar */}
                        <NavLink to="/crear" className="nav-link" onClick={toggleMenu}>
                            <FaPlus className="me-2" /> Agregar
                        </NavLink>

                        {/* Botón Tabla */}
                        <NavLink to="/tabla" className="nav-link" onClick={toggleMenu}>
                            <FaTable className="me-2" /> Tabla
                        </NavLink>

                        {/* Botón Logout */}
                        <button className="nav-link btn-logout" onClick={handleLogout}>
                            <FaSignOutAlt className="me-2" /> Logout
                        </button>
                    </div>
                )}

                {/* MODAL PANTALLA COMPLETA */}
                <Modal
                    show={showAgregarModal}
                    onHide={closeAgregarModal}
                    fullscreen={true}
                    scrollable
                    backdrop="static"
                    dialogClassName="custom-fullscreen-modal"
                >
                    <Modal.Header closeButton className="custom-modal-header">
                        <Modal.Title><Link to="crear" /></Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="custom-modal-body-content">
                        <Crear
                            isModal={true}
                            onSuccess={closeAgregarModal}
                            className="custom-modal-form"
                        />
                    </Modal.Body>
                </Modal>
            </header>
            <main className="main-mostrart">
            </main>
        </>
    );
};

export default HeaderRoot;